import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerGlideProps = {
  component: object;
  range: object;
  safeVersion?: string;
  safeCommitHash?: string;
  unsafeVersion?: string;
  unsafeCommitHash?: string;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerGlide: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerGlideProps
> = props => {
  let component = props.component,
    range = props.range || {},
    safeVersion = props.safeVersion,
    safeCommitHash = props.safeCommitHash,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    unsafeCommitHash =
      props.unsafeCommitHash || (range.versionRange === 'HEAD' ? range.endCommit : ''),
    transitive = props.transitive === undefined ? false : props.transitive;
  let diff = null;
  if (!transitive) {
    diff = (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="glide.yaml" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="delete" text={`- package  ${component.coordinate1}`} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={`\u00A0\u0020version  ${unsafeCommitHash || unsafeVersion}`}
        />
        <ArtifactViewCodeDiffDisplay type="add" text={`- package  ${component.coordinate1}`} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={`\u00A0\u0020version  ${safeCommitHash || safeVersion}`}
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
      </div>
    );
  } else {
    diff = (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="glide.yaml" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="add" text={`- package  ${component.coordinate1}`} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={`\u00A0\u0020version  ${safeCommitHash || safeVersion}`}
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
      </div>
    );
  }
  return (
    <div className="pt-">
      <div className="grid p0 mt">
        <div>
          {!transitive && (
            <span className="p0 pv-">
              {' '}
              Update your <span className="text--bold"> glide.yaml </span>
            </span>
          )}
          {transitive && (
            <span className="p0 pv-">
              {' '}
              Include {name} to your <span className="text--bold">glide.yaml</span>
            </span>
          )}
          <span className="pv-">&nbsp;as shown below:</span>
        </div>
      </div>
      {diff}
      <div className="grid pt">
        <span className="grid__item pv- p0">
          After updating glide.yaml, type the following to update. This will also update other
          libraries in glide.yaml
        </span>
      </div>
      <div className="pt-- -ml mt">
        <span className="font-family--code bg-color--white-medium p-">glide up</span>
      </div>

      <div className="grid mt">
        <span className="grid__item p0">
          If you are using <strong>Trash</strong> package manager, type the following instead
        </span>
      </div>
      <div className="pt-- -ml mt">
        <span className="font-family--code bg-color--white-medium p-">trash</span>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerGlide;
